<template>
  <div class="coaching-default coaching-board">
    <div class="coaching__header">
      <h1 class="coaching__title">
        {{ topicTitle }}
        <span class="subtitle is-5">{{ scenarioTitle }}</span>
      </h1>
    </div>

    <div class="coaching__content">
      <div class="coaching__board">
        <slot name="board"></slot>
      </div>
      <div class="coaching__classroll" v-if="showClassRoll">
        <slot name="classroll"></slot>
      </div>
    </div>

    <div class="coaching__controls">
      <slot name="controls"></slot>
    </div>

    <div class="coaching__keyboard-help">
      <slot name="keyboard-help"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "CoachingDefaultLayout",
  props: {
    topicTitle: {
      type: String,
      default: "",
    },
    scenarioTitle: {
      type: String,
      default: "",
    },
    showClassRoll: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.coaching-default {
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.coaching__content {
  flex: 1;
  display: flex;
  gap: 2rem;
  align-items: flex-start;
  justify-content: center;
}

.coaching__classroll {
  width: 450px;
  height: var(--board-size, 560px);
  flex-shrink: 0;
}

.coaching__controls {
  margin-top: 1rem;
  padding: 1rem 0;
}
</style>
